import { Chakra } from "@airhelp/react-ui-components";
import { useState } from "react";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import { FormSuccessMessage } from "components/FormControl";
import SubscribeForm from "./SubscribeForm";

const { Flex, Heading, Box } = Chakra;

export interface SubscribeProps {
  heading: string;
  text: string;
  buttonText: string;
  listId?: string;
}

const Subscribe = ({ heading, text, buttonText, listId = "blog" }: SubscribeProps) => {
  const [hasSubscribed, setHasSubscribed] = useState(false);
  const translations = useTranslations();

  return (
    <Flex flexDir="column" align="flex-start" color="white" py={6}>
      <Heading color="inherit" variant="h2" as="h2" pb={2} w={{ base: "full", lg: "60%" }} textAlign="left">
        {heading}
      </Heading>
      <Box w={{ base: "full", lg: "58%" }} textAlign="left">
        {text}
      </Box>
      {!hasSubscribed ? (
        <SubscribeForm setHasSubscribed={setHasSubscribed} buttonText={buttonText} listId={listId} />
      ) : (
        <FormSuccessMessage text={translations("subscribe_form_submit_succesful")} />
      )}
    </Flex>
  );
};

export default Subscribe;
